import moment from 'moment';
import _ from 'lodash';

export default class EventsService {
  constructor(SeldaAPIService, $q) {
    'ngInject';
    Object.assign(this, {SeldaAPIService, $q});
  }

  /**
   * Retrieve list of all offices
   */
  list() {
    return this.SeldaAPIService.requestService('eventi', {sedi: ''})
      // add a start date property to events as moment js object and sort events by that property
      .then((events) => _(events)
        .map((e) => _.extend(e, {start_timestamp: moment(e.da, 'DD/MM/YYYY HH:mm')}))
        .sortBy('start_timestamp')
        .value()); // unwrap returned events
  }

  /**
   * Retrieve a single event
   * @param officeId
   * @param eventId
   */
  find(officeId, eventId) {
    return this.SeldaAPIService.requestService('eventi', {sedi: officeId})
      // add a start date property to events as moment js object and sort events by that property
      .then((events) => _(events)
        .map((e) => _.extend(e, {start_timestamp: moment(e.da, 'DD/MM/YYYY HH:mm')}))
        .find((e) => e.id_elemento == eventId)); // find event identified by the given id
  }

  /**
   * Return a full event object decorated with event content
   * @param eventId
   * @param officeId
   */
  details(officeId, eventId) {
    // parallelize calls using $q.all
    console.debug('Retrieving details for event', eventId, 'in office', officeId);
    let promises = [
      this.find(officeId, eventId),
      this.SeldaAPIService.requestService('contenutoEvento', {id: eventId, id_sede: officeId})
    ];

    return this.$q.all(promises).then(result => {
      let event = result[0], content = _.isEmpty(result[1]) ? null : result[1][0].content;
      return _.extend(event, {content: content});
    });
  }

}


// WEBPACK FOOTER //
// ./client/app/services/events_service.js